import { NotificationLevel, NotificationsService } from './../../../../services/api/notifications/notifications.service';
import { Queue, TaskManagementService } from 'src/app/services/api/taskmanagement/taskmanagement.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-queue',
  templateUrl: './delete-queue.component.html',
  styleUrls: ['./delete-queue.component.scss']
})
export class DeleteQueueComponent implements OnInit {

  constructor(
    private taskmanagementService:TaskManagementService,
    private notificationsService:NotificationsService,
    public dialogRef: MatDialogRef<DeleteQueueComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      queue: Queue;
    }) { }

  ngOnInit() {
  }

  confirm(){
    this.taskmanagementService.deleteQueue(this.data.queue.queueId).subscribe(
      () => {
        this.notificationsService.showNotification(`La cola ${this.data.queue.name} se ha eliminado correctamente`, NotificationLevel.SUCCESS);
        this.dialogRef.close();
      },
      (error) => {
        this.notificationsService.showNotification(
          `Ha habido un problema al eliminar la cola ${this.data.queue.name}`,
          NotificationLevel.ERROR);
      }
    );
  }

}
